import "./LoadingHeading.scss";

const LoadingHeading = () => (
  <div className="heading">
    <div>G</div>
    <div>N</div>
    <div>I</div>
    <div>D</div>
    <div>A</div>
    <div>O</div>
    <div>L</div>
  </div>
);

export default LoadingHeading;
